import React from 'react';
import { __ } from '../../../../utils/translation-service';
import { IFooterContactInfo } from '@interfaces/IFooter';

interface IFooterContactInfoProps extends IFooterContactInfo {
    className?: string;
    title: string;
    content?: string;
}
export class FooterContactInfo extends React.Component<IFooterContactInfoProps, {}> {
    public render() {
        const showJobButtonLink =
            !!this.props.jobButton?.targetUrl && this.props.jobButton?.linkTitle;
        return (
            <>
                <h3
                    className="text-uppercase"
                    style={{
                        lineHeight: '1.1',
                        fontSize: '12px',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                    }}
                >
                    {this.props.title}
                </h3>
                <div className="clearfix" />

                {/** TODO: remove HTML String, this is bad */}
                <div
                    className="footer-contact-us"
                    dangerouslySetInnerHTML={{ __html: this.props.content || '' }}
                />

                <div className="footerJobButton">
                    {showJobButtonLink && (
                        <>
                            <a
                                href={this.props.jobButton?.targetUrl}
                                className="newsletterFooterButton btn btn-more"
                                role="button"
                            >
                                {this.props.jobButton?.linkTitle}
                            </a>
                            &nbsp;
                        </>
                    )}
                    <a href={__('blogLink')} className="btn btn-more">
                        {__('cruiseNews')}
                    </a>
                </div>
                <br />
            </>
        );
    }
}
